import $ from './jquery';
import {TweenMax, TimelineLite} from 'gsap';
import ScrollMagic from 'scrollmagic';
import 'scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap';
import 'scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators';
import Swiper from './lib/swiper';
import Vivus from 'vivus';

/*!
 * original script
 */


/* toggle navi menu (for SP)
----------------------------------------------------------------- */
$(function() {
    var $btn = $('.js-hamburger'),
        $target = $('.js-header'),
        currentScrollY;
    $btn.on('click', function() {
        if ( $target.hasClass('is-active') ) {
            $target.removeClass('is-active');
            $('body').attr({ style: '' });
            $(window).scrollTop(currentScrollY);
        } else {
            $target.addClass('is-active');
            currentScrollY = $( window ).scrollTop();
            $('body').css({
                position: 'fixed',
                width: '100%',
                top: -1*currentScrollY
            });
            return currentScrollY;
        }
    });
});

// mini header
// --------------------------------------------------------------- //
$(function() {
    let $header = $('.js-header');
    let $window = $(window);
    $window.on('load scroll', function(){
        $window.on('load scroll', function () {
            if ($window.scrollTop() > 40) {
                $('header').addClass('is-fixed');
            } else {
                $('header').removeClass('is-fixed');
            }
        });
    });
});


/* smooth scroll
----------------------------------------------------------------- */
$(function(){
    $('a[href^="#"]').click(function(){
        var speed = 500,
            href= $(this).attr("href"),
            target = $(href == "#" || href == "" ? 'html' : href),
            position = target.offset().top;
    $("html, body").animate({scrollTop:position}, speed, "swing");
        return false;
    });
});

/* //固定グローバルナビの横スクロール時の位置
----------------------------------------------------------------- */
$(window).on('load resize', function(){
    var breakpointTAB = 1080,
        windowWidth = parseInt($(window).width());
    var target = $('.js-header');
    if ( windowWidth < breakpointTAB ) {
        $(window).scroll( function() {
            var scrollPos = $(window).scrollLeft();
            target.css({
                left: -scrollPos
            });
        });
    }
});
